import { render, staticRenderFns } from "./AppPager.vue?vue&type=template&id=71c08d8a&scoped=true&"
import script from "./AppPager.vue?vue&type=script&lang=js&"
export * from "./AppPager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c08d8a",
  null
  
)

export default component.exports